import { render, staticRenderFns } from "./JobReview.vue?vue&type=template&id=78098c9e&scoped=true&"
import script from "./JobReview.vue?vue&type=script&lang=js&"
export * from "./JobReview.vue?vue&type=script&lang=js&"
import style0 from "./JobReview.vue?vue&type=style&index=0&id=78098c9e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "78098c9e",
  null
  
)

export default component.exports